import { FETCH_ITEM_COPIES_META, FETCHING_ITEM_COPIES_META, EDIT_ITEM_COPIES_META } from "../actionTypes";

export const fetchingItemCopiesMeta = payload => ({
    type: FETCHING_ITEM_COPIES_META,
    payload
});

export const fetchItemCopiesMeta = payload => ({
    type: FETCH_ITEM_COPIES_META,
    payload
});

export const editItemCopiesMeta = payload => ({
    type: EDIT_ITEM_COPIES_META,
    payload
});